'use client';
import styles from './style.module.scss';

export default function Index() {
	return (
		<div className={styles.header}>
			<div className={styles.logo}>
				<img src="/images/FL2.png" alt="Logo" className={styles.logoImage} />
			</div>
		</div>
	);
}
